import { formatTime } from "../../../utils/FormattingUtils";
import { TransformationTags } from "../../calculation/TransformationTags";
import { PlayerContextState } from "../../PlayerContext";
import { getResourceAmount, grantResource, Resource } from "../../Resources";
import { getTotalElementAndSchoolExp } from "../../spells/ElementsAndSchools";
import {
  ActionBase,
  ActionEffect,
  ActionSubcategory,
  DoActionArgs,
} from "../Action";

class UseTimePiecesWarp extends ActionBase {
  constructor() {
    super();
  }

  isVisible(state: PlayerContextState): boolean {
    return (
      getResourceAmount(state, Resource.TimePieces) > 0 &&
      getTotalElementAndSchoolExp(state) > 10000
    );
  }

  canSpam(): boolean {
    return false;
  }

  getName(): string {
    return "Use Time Pieces (Warp)";
  }

  getArea(): string {
    return "Campus";
  }

  getSubcategory(): ActionSubcategory | undefined {
    return ActionSubcategory["Use Time Pieces"];
  }

  getDisplayDescription(): string {
    return "Use your time pieces to warp time, affecting every aspect of the game.";
  }

  protected getBaseActionEffects(): Record<string, ActionEffect> {
    return {
      timePiecePerWarpedSec: {
        value: 5,
        tags: [TransformationTags.TimePiecePerWarpedSec],
      },
    };
  }

  getDisplayEffect(state: PlayerContextState): string {
    const cost = this.getCost(state).resources["Time Pieces"] ?? 1;
    const effect = this.getActionEffects(state);
    const totalSecs = cost / effect.timePiecePerWarpedSec;
    return `Warp time forward by ${formatTime(totalSecs, {
      shortForm: false,
      showDecimals: false,
    })} (Real World)`;
  }

  canAfford(state: PlayerContextState): boolean {
    return (
      super.canAfford(state) &&
      getResourceAmount(state, Resource.TimePieces) >= 3000
    );
  }

  getCost(state: PlayerContextState): {
    resources: Partial<Record<Resource, number>>;
    items: Record<string, number>;
  } {
    return {
      resources: {
        "Time Pieces": 3000,
      },
      items: {},
    };
  }

  doAction(args: DoActionArgs, state: PlayerContextState): PlayerContextState {
    const cost = this.getCost(state).resources["Time Pieces"] ?? 1;
    const effect = this.getActionEffects(state);
    const totalSecs = cost / effect.timePiecePerWarpedSec;
    state = grantResource(Resource.TimePieces, -cost)(state);
    state.warpTimeSecs = totalSecs;

    return state;
  }
}

export default new UseTimePiecesWarp();
